import { render, staticRenderFns } from "./EventContestEntryFormStep3.vue?vue&type=template&id=db854fe2"
import script from "./EventContestEntryFormStep3.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventContestEntryFormStep3.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db854fe2')) {
      api.createRecord('db854fe2', component.options)
    } else {
      api.reload('db854fe2', component.options)
    }
    module.hot.accept("./EventContestEntryFormStep3.vue?vue&type=template&id=db854fe2", function () {
      api.rerender('db854fe2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/EventContestEntryFormStep3.vue"
export default component.exports